// import { useState, useContext } from 'react';
// import {
//   Card,
//   Box,
//   Typography,
//   IconButton,
//   Button,
//   CircularProgress
// } from '@mui/material';
// import CallIcon from '@mui/icons-material/Call';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import GuestLoginModal from '../../GuestLoginModal';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BASE_URL } from './../../Api/ApiUrls';
// const formatPropertyId = (id) => {
//   return `PR${String(id).padStart(4, '0')}`;
// };

// const getPriceLabel = (price) => {
//   const num = Number(price);
//   if (num >= 10000000) {
//     return `${(num / 10000000).toFixed(2)} Cr`;
//   } else if (num >= 100000) {
//     return `${(num / 100000).toFixed(2)} L`;
//   } else if (num >= 1000) {
//     return `${(num / 1000).toFixed(2)} K`;
//   }
//   return num.toLocaleString('en-IN');
// };

// // Default images for different property types
// const getDefaultImageByType = (propertyType) => {
//   const typeImages = {
//     'Plots': 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=80&h=80&fit=crop',
//     'Land': 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=80&h=80&fit=crop',
//     'Flat': 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=80&h=80&fit=crop',
//     'House': 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=80&h=80&fit=crop',
//     'Villa': 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=80&h=80&fit=crop',
//     'Commercial Building': 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=80&h=80&fit=crop',
//     'Residential Building': 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=80&h=80&fit=crop'
//   };
//   return typeImages[propertyType] || 'https://via.placeholder.com/80x80?text=No+Image';
// };

// export default function AuctionPropertyCard({ 
//   property, 
//   onCardClick, 
//   onCallClick, 
//   onMapClick,
//   images = [],
//   showAlert,
//   selected = false  
// }) {
//   const { isGuest } = useContext(AuthContext);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isLoadingLocation, setIsLoadingLocation] = useState(false);
//   const [imageErrors, setImageErrors] = useState({});
//   const [showGuestModal, setShowGuestModal] = useState(false);
// const navigate = useNavigate();
//   const hasMultipleImages = images.length > 1;
//   const currentImage = images[currentImageIndex] || { url: null };

//   const getImageUrl = (url) => {
//     if (!url) return getDefaultImageByType(property.property_type);
//     return url;
//   };

//   const handleImageError = () => {
//     setImageErrors(prev => ({ ...prev, [currentImageIndex]: true }));
//   };

//   const getCurrentImageUrl = () => {
//     if (imageErrors[currentImageIndex] || !currentImage?.url) {
//       return getDefaultImageByType(property.property_type);
//     }
//     return currentImage.url;
//   };

//   const nextImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   const handleDotClick = (index, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(index);
//   };

//   // ✅ Guest check helper
//   const checkGuestAndExecute = (actionCallback) => {
//     if (isGuest) {
//       setShowGuestModal(true);
//       return false;
//     }
//     return actionCallback();
//   };

// // Handle location click
// const handleLocationClick = (e) => {
//   e.stopPropagation();
  
//   checkGuestAndExecute(() => {
//     setIsLoadingLocation(true);

//     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

//     const openInMaps = (url) => {
//       setIsLoadingLocation(false);
//       window.location.href = url;
//     };

//     const fallbackUrl = isIOS
//       ? `http://maps.apple.com/?q=${encodeURIComponent(property.location || '')}`
//       : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location || `${property.lat},${property.lng}`)}`;

//     if (property.lat && property.lng && navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const userLat = position.coords.latitude;
//           const userLng = position.coords.longitude;
//           const mapsUrl = isIOS
//             ? `http://maps.apple.com/?daddr=${property.lat},${property.lng}`
//             : `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${property.lat},${property.lng}&travelmode=driving`;
//           openInMaps(mapsUrl);
//         },
//         (error) => {
//           console.error("Error getting user location:", error);
//           openInMaps(fallbackUrl);
//         },
//         { timeout: 10000 }
//       );
//     } else {
//       openInMaps(fallbackUrl);
//     }
//   });
// };


// const handleCallClick = (e) => {
//   e.stopPropagation();
  
//   // First check if user is guest
//   if (isGuest) {
//     setShowGuestModal(true);
//     return;
//   }
  
//   // Check for phone number in multiple possible locations
//   const phoneNumber =
//                      property.bankContactDetails ;
  
//   if (phoneNumber) {
//     // Copy to clipboard
//     navigator.clipboard.writeText(phoneNumber)
//       .then(() => {
//         if (showAlert) {
//           showAlert('success', `Phone number copied: ${phoneNumber}`);
//         } else {
//           alert(`Phone number copied: ${phoneNumber}`);
//         }
//       })
//       .catch((error) => {
//         console.error('Failed to copy:', error);
//         if (showAlert) {
//           showAlert('failure', 'Failed to copy phone number');
//         } else {
//           alert('Failed to copy phone number');
//         }
//       });
//   } else {
//     // Try to fetch from user endpoint as fallback
//     const userId = property.user_id || property.userId;
//     if (userId) {
//       axios.get(`${BASE_URL}/users/${userId}/`)
//         .then(response => {
//           const user = response.data;
//           const userPhone = user?.mobile_no || user?.bankContactDetails || user?.phone;
//           if (userPhone) {
//             return navigator.clipboard.writeText(userPhone);
//           } else {
//             throw new Error('No phone number found');
//           }
//         })
//         .then(() => {
//           if (showAlert) {
//             showAlert('success', 'Phone number copied successfully');
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching phone number:', error);
//           if (showAlert) {
//             showAlert('failure', 'No contact information available');
//           } else {
//             alert('No contact information available');
//           }
//         });
//     } else {
//       if (showAlert) {
//         showAlert('failure', 'No contact information available');
//       } else {
//         alert('No contact information available');
//       }
//     }
//   }
// };
// const handleCardClick = (e) => {
//   const isButtonClick = e.target.closest('button') || 
//                         e.target.closest('svg') || 
//                         e.target.closest('path');
//   if (!isButtonClick) {
//     if (isGuest) {
//       setShowGuestModal(true);
//       return;
//     }
//           localStorage.setItem('lastViewedPropertyId', property.id);

//     navigate(`/Post_Bankcard_indetail/${property.id}`);
//   }
// };

//   return (
//     <>
//   <Card
//         onClick={handleCardClick}
//         sx={{
//           display: "flex",
//           flexDirection: "row",
//           width: '100%',
//           height: 125,
//           maxWidth: 290,
//           cursor: 'pointer',
//           borderRadius: 2,
//           overflow: 'hidden',
//           border: selected ? '2px solid #FFD600' : '2px solid transparent',
//           transform: selected ? 'translateY(-2px)' : 'none',
//           transition: 'transform 200ms, border-color 200ms',
//           boxShadow: selected ? '0 4px 12px rgba(0,0,0,0.5)' : '0 2px 6px rgba(0,0,0,0.3)',
//           bgcolor: '#fff',
//           flexShrink: 0,
//         }}
//       >
//         {/* IMAGE SECTION */}
//         <Box
//           sx={{
//             width: 80,
//             height: 115, 
//             ml: 1,
//             borderRadius: "10px",
//             overflow: "hidden",
//             position: "relative",
//             flexShrink: 0,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           {images.length > 0 ? (
//             <>
//               <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
//                 <img
//                   src={getCurrentImageUrl()}
//                   alt="Property"
//                   onError={handleImageError}
//                   style={{ 
//                     width: "100%", 
//                     height: "100%", 
//                     objectFit: "cover",
//                     objectPosition: "center"
//                   }}
//                 />
                
//                 {hasMultipleImages && (
//                   <IconButton
//                     onClick={prevImage}
//                     sx={{
//                       position: "absolute",
//                       left: 2,
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                       backgroundColor: "rgba(255, 255, 255, 0.8)",
//                       width: 20,
//                       height: 20,
//                       minWidth: 20,
//                       padding: 0,
//                       '&:hover': {
//                         backgroundColor: "rgba(255, 255, 255, 0.9)",
//                       }
//                     }}
//                   >
//                     <ChevronLeftIcon sx={{ fontSize: 14 }} />
//                   </IconButton>
//                 )}
                
//                 {hasMultipleImages && (
//                   <IconButton
//                     onClick={nextImage}
//                     sx={{
//                       position: "absolute",
//                       right: 2,
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                       backgroundColor: "rgba(255, 255, 255, 0.8)",
//                       width: 20,
//                       height: 20,
//                       minWidth: 20,
//                       padding: 0,
//                       '&:hover': {
//                         backgroundColor: "rgba(255, 255, 255, 0.9)",
//                       }
//                     }}
//                   >
//                     <ChevronRightIcon sx={{ fontSize: 14 }} />
//                   </IconButton>
//                 )}
//               </Box>
              
//               {/* DOTS INDICATOR */}
//               {hasMultipleImages && (
//                 <Box sx={{ 
//                   display: 'flex', 
//                   justifyContent: 'center', 
//                   mt: 0.5, 
//                   gap: 0.5,
//                   position: "absolute",
//                   bottom: 4,
//                   left: 0,
//                   right: 0,
//                 }}>
//                   {images.map((_, index) => (
//                     <Box
//                       key={index}
//                       onClick={(e) => handleDotClick(index, e)}
//                       sx={{
//                         width: 6,
//                         height: 6,
//                         borderRadius: '50%',
//                         backgroundColor: index === currentImageIndex ? '#1976d2' : '#ccc',
//                         cursor: 'pointer',
//                         '&:hover': {
//                           backgroundColor: index === currentImageIndex ? '#1976d2' : '#aaa',
//                         }
//                       }}
//                     />
//                   ))}
//                 </Box>
//               )}
//             </>
//           ) : (
//             /* NO IMAGE STATE */
//             <Box sx={{ 
//               width: "100%", 
//               height: "100%", 
//               display: "flex", 
//               flexDirection: "column",
//               alignItems: "center", 
//               justifyContent: "center",
//               backgroundColor: "#f5f5f5"
//             }}>
//               <NoPhotographyIcon sx={{ fontSize: 24, color: "#999", mb: 1 }} />
//               <Typography 
//                 variant="caption" 
//                 sx={{ 
//                   fontSize: "10px", 
//                   color: "#666",
//                   textAlign: "center",
//                   px: 1
//                 }}
//               >
//                 No Image Available
//               </Typography>
//             </Box>
//           )}
//         </Box>

//         {/* CONTENT SECTION - Your original content preserved */}
//         <Box sx={{ 
//           flex: 1, 
//           px: 1.2, 
//           minWidth: 0,
//           height: 120, 
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "space-between"
//         }}>
//           {/* Property ID and Price in one row with space-between */}
//           <Box sx={{
//             display: 'flex', 
//             flexDirection: 'row', 
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             width: '100%',
//             mb: 0.8,
//           }}>
//             <Typography
//               fontSize="10px"
//               sx={{
//                 fontWeight: 400,
//                 maxWidth: '75%',
//                 whiteSpace: 'normal', 
//               }}
//             >
//               <b>Property ID:</b> {formatPropertyId(property?.id || property?.bankprop_id)}
//             </Typography>

//             <Typography
//               fontSize="10px"
//               sx={{
//                 backgroundColor: "#000000cb",
//                 color: "#fff",
//                 borderRadius: "50px",
//                 minWidth: "35px",
//                 padding: "2px 6px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 textAlign: "center",
//                 whiteSpace: "nowrap"
//               }}
//             >
//               ₹ {getPriceLabel(property.reserve_price || property.price)}
//             </Typography>
//           </Box>

//           {/* Property details with margins */}
//           <Box sx={{ 
//             flex: 1, 
//             overflow: "hidden",
//             display: "flex",
//             flexDirection: "column"
//           }}>
//             <Box mb={0.3}>
//               <Typography fontSize="10px" noWrap sx={{ lineHeight: 1.2 }}>
//                 <b>Property:</b> {property.propertyType || ""}
//               </Typography>
//             </Box>

//             <Box mb={0.3}>
//               <Typography fontSize="10px" noWrap sx={{ lineHeight: 1.2 }}>
//                 <b>City/Town:</b> {property.city_town || property.city || "-"}
//               </Typography>
//             </Box>
            
//             <Box mb={0.3}>
//               <Typography fontSize="10px" noWrap sx={{ lineHeight: 1.2 }}>
//                 <b>Location:</b> {property.area_town || property.locality || "-"}
//               </Typography>
//             </Box>
            
//             <Box mb={0.2}>
//               <Typography fontSize="10px" noWrap sx={{ lineHeight: 1.2 }}>
//                 <b>Bank:</b> {property.bankName || property.title || "-"}
//               </Typography>
//             </Box>
            
//             <Box mb={0.3}>
//               <Typography fontSize="10px" noWrap sx={{ lineHeight: 1.2 }}>
//                 <b>Auction Date:</b>{" "}
//                 {property.auctionEnd ? (
//                   `${new Date(property.auctionStart).toLocaleDateString("en-IN")} – ${new Date(property.auctionEnd).toLocaleDateString("en-IN")}`
//                 ) : (
//                   "-"
//                 )}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Buttons at the bottom */}
//           <Box sx={{ 
//             display: "flex", 
//             justifyContent: 'space-evenly', 
//             gap: 0.5
//           }}>
//             <Button 
//               size="small" 
//               variant="outlined" 
//               startIcon={<CallIcon />}
//               onClick={handleCallClick}
//               sx={{ 
//                 minWidth: '58px',
//                 fontSize: '10px',
//                 padding: '1px 3px',
//                 height: '22px',
//                 flex: 1
//               }}
//             >
//               Call
//             </Button>

//             <Button 
//               size="small" 
//               variant="outlined" 
//               startIcon={!isLoadingLocation && <LocationOnIcon />}
//               onClick={handleLocationClick}
//               disabled={isLoadingLocation}
//               sx={{ 
//                 minWidth: '58px',
//                 fontSize: '10px',
//                 padding: '1px 3px',
//                 height: '22px',
//                 flex: 1
//               }}
//             >
//               {isLoadingLocation ? (
//                 <CircularProgress size={14} color="inherit" />
//               ) : (
//                 "Map"
//               )}
//             </Button>
//           </Box>
//         </Box>
//       </Card>

//       {/* Guest Login Modal */}
//       <GuestLoginModal
//         open={showGuestModal}
//         onClose={() => setShowGuestModal(false)}
//       />
//     </>
//   );
// }



// import { useState, useContext } from 'react';
// import {
//   Card, CardMedia, CardContent, Box, Typography,
//   IconButton, Button, CircularProgress,
// } from '@mui/material';
// import {
//   Call, LocationOn, ChevronLeft, ChevronRight, ArrowForward,
// } from '@mui/icons-material';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import GuestLoginModal from '../../GuestLoginModal';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BASE_URL } from './../../Api/ApiUrls';

// // ─── Helpers ─────────────────────────────────────────────────────────────────
// const formatPropertyId = (id) => `PR${String(id || '').padStart(4, '0')}`;

// const formatPrice = (price) => {
//   const num = Number(price);
//   if (!num || isNaN(num) || num <= 0) return '0';
//   return num.toLocaleString('en-IN');
// };

// const getPriceLabel = (price) => {
//   const num = Number(price);
//   if (!num || isNaN(num) || num <= 0) return '0';
//   if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
//   if (num >= 100000)   return `${(num / 100000).toFixed(2)} L`;
//   if (num >= 1000)     return `${(num / 1000).toFixed(2)} K`;
//   return num.toLocaleString('en-IN');
// };

// const getDefaultImageByType = (propertyType) => {
//   const typeImages = {
//     'Plots': 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=200&h=200&fit=crop',
//     'Land': 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=200&h=200&fit=crop',
//     'Flat': 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=200&h=200&fit=crop',
//     'House': 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=200&h=200&fit=crop',
//     'Villa': 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=200&h=200&fit=crop',
//     'Commercial Building': 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=200&h=200&fit=crop',
//     'Residential Building': 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=200&h=200&fit=crop',
//   };
//   return typeImages[propertyType] || '/default-property-image.jpg';
// };

// export default function AuctionPropertyCard({
//   property,
//   onCardClick,
//   onCallClick,
//   onMapClick,
//   images = [],
//   showAlert,
//   selected = false,
// }) {
//   const { isGuest } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isLoadingLocation, setIsLoadingLocation] = useState(false);
//   const [imageErrors, setImageErrors] = useState({});
//   const [showGuestModal, setShowGuestModal] = useState(false);

//   const hasMultipleImages = images.length > 1;

//   const getImageUrl = (url) => url || getDefaultImageByType(property.property_type);

//   const handleImageError = () => {
//     setImageErrors((prev) => ({ ...prev, [currentImageIndex]: true }));
//   };

//   const getCurrentImageUrl = () => {
//     if (images.length === 0) return getDefaultImageByType(property.property_type);
//     const img = images[currentImageIndex];
//     const raw = typeof img === 'string' ? img : (img?.url || img?.image || '');
//     if (imageErrors[currentImageIndex] || !raw) {
//       return getDefaultImageByType(property.property_type);
//     }
//     return raw.startsWith('http') ? raw : `${BASE_URL}/${raw.replace(/^\/+/, '')}`;
//   };

//   const nextImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   const handleDotClick = (index, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(index);
//   };

//   // ── Guest check ──────────────────────────────────────────────────────────
//   const checkGuestAndExecute = (cb) => {
//     if (isGuest) { setShowGuestModal(true); return false; }
//     return cb();
//   };

//   // ── Location ─────────────────────────────────────────────────────────────
//   const handleLocationClick = (e) => {
//     e.stopPropagation();
//     checkGuestAndExecute(() => {
//       setIsLoadingLocation(true);
//       const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
//       const openInMaps = (url) => { setIsLoadingLocation(false); window.location.href = url; };
//       const fallbackUrl = isIOS
//         ? `http://maps.apple.com/?q=${encodeURIComponent(property.location || '')}`
//         : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location || `${property.lat},${property.lng}`)}`;

//       if (property.lat && property.lng && navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const { latitude, longitude } = position.coords;
//             const mapsUrl = isIOS
//               ? `http://maps.apple.com/?daddr=${property.lat},${property.lng}`
//               : `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${property.lat},${property.lng}&travelmode=driving`;
//             openInMaps(mapsUrl);
//           },
//           () => openInMaps(fallbackUrl),
//           { timeout: 10000 }
//         );
//       } else {
//         openInMaps(fallbackUrl);
//       }
//     });
//   };

//   // ── Call ─────────────────────────────────────────────────────────────────
//   const handleCallClick = (e) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }

//     const phoneNumber = property.bankContactDetails;

//     if (phoneNumber) {
//       navigator.clipboard.writeText(phoneNumber)
//         .then(() => showAlert?.('success', `Phone number copied: ${phoneNumber}`))
//         .catch(() => showAlert?.('failure', 'Failed to copy phone number'));
//     } else {
//       const userId = property.user_id || property.userId;
//       if (userId) {
//         axios.get(`${BASE_URL}/users/${userId}/`)
//           .then((r) => {
//             const user = r.data;
//             const userPhone = user?.mobile_no || user?.bankContactDetails || user?.phone;
//             if (userPhone) return navigator.clipboard.writeText(userPhone);
//             throw new Error('No phone number found');
//           })
//           .then(() => showAlert?.('success', 'Phone number copied successfully'))
//           .catch(() => showAlert?.('failure', 'No contact information available'));
//       } else {
//         showAlert?.('failure', 'No contact information available');
//       }
//     }
//   };

//   // ── Card click ───────────────────────────────────────────────────────────
//   const handleCardClick = (e) => {
//     const isButtonClick = e.target.closest('button') ||
//                           e.target.closest('svg') ||
//                           e.target.closest('path');
//     if (isButtonClick) return;
//     if (isGuest) { setShowGuestModal(true); return; }
//     localStorage.setItem('lastViewedPropertyId', property.id);
//     navigate(`/Post_Bankcard_indetail/${property.id}`);
//   };

//   // ── Display values ───────────────────────────────────────────────────────
//   const auctionDateText = property.auctionEnd
//     ? `${new Date(property.auctionStart).toLocaleDateString('en-IN')} – ${new Date(property.auctionEnd).toLocaleDateString('en-IN')}`
//     : '-';

//   const locationLine = property.area_town || property.locality || '-';
//   const cityLine = property.city_town || property.city || '';
//   const bankName = property.bankName || property.title || '-';

//   return (
//     <>
//       <Card
//         onClick={handleCardClick}
//         sx={{
//           display: 'flex',
//           flexDirection: 'row',
//           width: '100%',
//           height: 135,
//           maxWidth: 290,
//           cursor: 'pointer',
//           borderRadius: 2,
//           overflow: 'hidden',
//           transform: selected ? 'translateY(-2px)' : 'none',
//           transition: 'transform 200ms, border-color 200ms',
//           boxShadow: selected
//             ? '0 4px 12px rgba(0,0,0,0.5)'
//             : '0 2px 6px rgba(0,0,0,0.3)',
//           bgcolor: '#fff',
//           flexShrink: 0,
//         }}
//       >
//         {/* ── LEFT: Image 38% ─────────────────────────────────────────────── */}
//         <Box sx={{ position: 'relative', width: '38%', height: '100%' }}>
//           <CardMedia
//             component="img"
//             image={getCurrentImageUrl()}
//             alt="Property"
//             onError={handleImageError}
//             sx={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               borderTopLeftRadius: 8,
//               borderBottomLeftRadius: 8,
//             }}
//           />

//           {hasMultipleImages && (
//             <>
//               <IconButton
//                 onClick={prevImage}
//                 sx={{
//                   position: 'absolute', top: '50%', left: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.5)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//               >
//                 <ChevronLeft fontSize="small" />
//               </IconButton>
//               <IconButton
//                 onClick={nextImage}
//                 sx={{
//                   position: 'absolute', top: '50%', right: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.5)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//               >
//                 <ChevronRight fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {hasMultipleImages && (
//             <Box sx={{
//               position: 'absolute', bottom: 6, left: '50%',
//               transform: 'translateX(-50%)', display: 'flex', gap: '4px',
//             }}>
//               {images.map((_, index) => (
//                 <Box
//                   key={index}
//                   onClick={(e) => handleDotClick(index, e)}
//                   sx={{
//                     width: 6, height: 6, borderRadius: '50%',
//                     backgroundColor: currentImageIndex === index ? '#1976d2' : '#ccc',
//                     cursor: 'pointer',
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>

//         {/* ── RIGHT: Content 62% ──────────────────────────────────────────── */}
//         <CardContent
//           sx={{
//             width: '62%', p: 1,
//             display: 'flex', flexDirection: 'column',
//             justifyContent: 'space-between',
//             height: 135, boxSizing: 'border-box',
//             '&:last-child': { pb: 1 },
//           }}
//         >
//           {/* Row 1: Property ID + Reserve Price badge */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.2 }}>
//             <Typography
//               fontWeight="bold"
//               noWrap
//               sx={{
//                 fontSize: '0.75rem', lineHeight: 1.2,
//                 overflow: 'hidden', textOverflow: 'ellipsis',
//                 maxWidth: '65%',
//               }}
//             >
//           {property.propertyType || property.property_type || '-'}
//             </Typography>

//             {/* <Typography
//               noWrap
//               sx={{
//                 backgroundColor: '#000000cb',
//                 color: '#fff',
//                 borderRadius: '50px',
//                 fontSize: '0.55rem',
//                 padding: '2px 6px',
//                 fontWeight: 600,
//                 whiteSpace: 'nowrap',
//               }}
//             >
//               ₹ {getPriceLabel(property.reserve_price || property.price)}
//             </Typography> */}
//           </Box>

//           {/* Row 2: Reserve Price / Auction Date */}
//           <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.1, mb: 0.2 }}>
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Reserve Price
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.68rem', color: '#c98a2c', lineHeight: 1.2 }}>
//                 ₹{formatPrice(property.reserve_price || property.price)}
//               </Typography>
//             </Box>

//             <Box sx={{ width: '1px', height: 26, bgcolor: '#e0e0e0', mx: 0.6 }} />

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Auction Date
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.6rem', lineHeight: 1.2 }} noWrap>
//                 {auctionDateText}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Row 3: Location + Call */}
//           <Box
//             sx={{
//               display: 'flex', alignItems: 'center', gap: 0.5,
//               mt: 0.1, mb: 0.1,
//               borderRadius: 1, px: 0.3,
//               transition: 'background-color 0.15s',
//               '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
//             }}
//           >
//             <LocationOn
//               onClick={handleLocationClick}
//               sx={{ fontSize: '0.9rem', color: '#c98a2c', flexShrink: 0, cursor: 'pointer' }}
//             />
//             <Box
//               onClick={handleLocationClick}
//               sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1, cursor: 'pointer' }}
//             >
//               <Typography
//                 noWrap
//                 sx={{
//                   fontSize: '0.6rem', color: '#333', fontWeight: 500,
//                   lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis',
//                   textDecoration: 'underline',
//                   textDecorationColor: 'rgba(201,138,44,0.4)',
//                 }}
//               >
//                 {locationLine}
//               </Typography>
//               {cityLine && (
//                 <Typography
//                   noWrap
//                   sx={{
//                     fontSize: '0.55rem', color: '#666', lineHeight: 1.2,
//                     overflow: 'hidden', textOverflow: 'ellipsis',
//                   }}
//                 >
//                   {cityLine}
//                 </Typography>
//               )}
//             </Box>

//             {/* <IconButton
//               size="small"
//               onClick={handleCallClick}
//               sx={{
//                 p: 0.3, flexShrink: 0, color: '#c98a2c',
//                 bgcolor: 'rgba(201,138,44,0.08)',
//                 '&:hover': {
//                   bgcolor: 'rgba(201,138,44,0.20)',
//                   transform: 'scale(1.08)',
//                 },
//                 transition: 'transform 0.15s, background-color 0.15s',
//                 width: 22, height: 22,
//               }}
//             >
//               <Call sx={{ fontSize: '0.85rem' }} />
//             </IconButton> */}
//           </Box>

//           {/* Row 4: Info Grid (Bank | Property) */}
//           <Box
//             sx={{
//               display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//               mt: 0.2, mb: 0.2, border: '1px solid #e0e0e0',
//               borderRadius: '8px', overflow: 'hidden', minHeight: 26,
//             }}
//           >
//             <Box sx={{ flex: 1.4, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1 }}>
//                 {bankName}
//               </Typography>
//               <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
//                 Bank
//               </Typography>
//             </Box>

//             {/* <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.4 }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1 }}>
//                 {property.propertyType || property.property_type || '-'}
//               </Typography>
//               <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
//                 Type
//               </Typography>
//             </Box> */}
//           </Box>

//           {/* Row 5: View Details */}
//           <Button
//             variant="contained"
//             size="small"
//             fullWidth
//             onClick={handleCardClick}
//             sx={{
//               mt: 0.2, py: 0.18,
//               fontSize: '0.7rem', fontWeight: 600,
//               bgcolor: '#c98a2c', color: '#000',
//               borderRadius: '2px',
//               '&:hover': { bgcolor: '#f5f5f5' },
//               textTransform: 'none',
//               minHeight: 22,
//               display: 'flex', justifyContent: 'space-between',
//               alignItems: 'center', px: 1.5,
//             }}
//           >
//             View Details
//             <ArrowForward sx={{ fontSize: '0.9rem' }} />
//           </Button>
//         </CardContent>
//       </Card>

//       <GuestLoginModal
//         open={showGuestModal}
//         onClose={() => setShowGuestModal(false)}
//       />
//     </>
//   );
// }


//[===========================================================================


// import { useState, useContext } from 'react';
// import {
//   Card, CardMedia, CardContent, Box, Typography,
//   IconButton, Button, CircularProgress,
// } from '@mui/material';
// import {
//   Call, LocationOn, ChevronLeft, ChevronRight, ArrowForward,
// } from '@mui/icons-material';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import GuestLoginModal from '../../GuestLoginModal';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BASE_URL } from './../../Api/ApiUrls';

// // ─── Helpers ─────────────────────────────────────────────────────────────────
// const formatPropertyId = (id) => `PR${String(id || '').padStart(4, '0')}`;

// const formatPrice = (price) => {
//   const num = Number(price);
//   if (!num || isNaN(num) || num <= 0) return '0';
//   return num.toLocaleString('en-IN');
// };

// const getPriceLabel = (price) => {
//   const num = Number(price);
//   if (!num || isNaN(num) || num <= 0) return '0';
//   if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
//   if (num >= 100000)   return `${(num / 100000).toFixed(2)} L`;
//   if (num >= 1000)     return `${(num / 1000).toFixed(2)} K`;
//   return num.toLocaleString('en-IN');
// };

// const getDefaultImageByType = (propertyType) => {
//   const typeImages = {
//     'Plots': 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=200&h=200&fit=crop',
//     'Land': 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=200&h=200&fit=crop',
//     'Flat': 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=200&h=200&fit=crop',
//     'House': 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=200&h=200&fit=crop',
//     'Villa': 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=200&h=200&fit=crop',
//     'Commercial Building': 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=200&h=200&fit=crop',
//     'Residential Building': 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=200&h=200&fit=crop',
//   };
//   return typeImages[propertyType] || '/default-property-image.jpg';
// };

// export default function AuctionPropertyCard({
//   property,
//   onCardClick,
//   onCallClick,
//   onMapClick,
//   images = [],
//   showAlert,
//   selected = false,
// }) {
//   const { isGuest } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isLoadingLocation, setIsLoadingLocation] = useState(false);
//   const [imageErrors, setImageErrors] = useState({});
//   const [showGuestModal, setShowGuestModal] = useState(false);

//   const hasMultipleImages = images.length > 1;

//   const getImageUrl = (url) => url || getDefaultImageByType(property.property_type);

//   const handleImageError = () => {
//     setImageErrors((prev) => ({ ...prev, [currentImageIndex]: true }));
//   };

//   const getCurrentImageUrl = () => {
//     if (images.length === 0) return getDefaultImageByType(property.property_type);
//     const img = images[currentImageIndex];
//     const raw = typeof img === 'string' ? img : (img?.url || img?.image || '');
//     if (imageErrors[currentImageIndex] || !raw) {
//       return getDefaultImageByType(property.property_type);
//     }
//     return raw.startsWith('http') ? raw : `${BASE_URL}/${raw.replace(/^\/+/, '')}`;
//   };

//   const nextImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   const handleDotClick = (index, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(index);
//   };

//   // ── Guest check ──────────────────────────────────────────────────────────
//   const checkGuestAndExecute = (cb) => {
//     if (isGuest) { setShowGuestModal(true); return false; }
//     return cb();
//   };

//   // ── Location ─────────────────────────────────────────────────────────────
//   const handleLocationClick = (e) => {
//     e.stopPropagation();
//     checkGuestAndExecute(() => {
//       setIsLoadingLocation(true);
//       const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
//       const openInMaps = (url) => { setIsLoadingLocation(false); window.location.href = url; };
//       const fallbackUrl = isIOS
//         ? `http://maps.apple.com/?q=${encodeURIComponent(property.location || '')}`
//         : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location || `${property.lat},${property.lng}`)}`;

//       if (property.lat && property.lng && navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const { latitude, longitude } = position.coords;
//             const mapsUrl = isIOS
//               ? `http://maps.apple.com/?daddr=${property.lat},${property.lng}`
//               : `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${property.lat},${property.lng}&travelmode=driving`;
//             openInMaps(mapsUrl);
//           },
//           () => openInMaps(fallbackUrl),
//           { timeout: 10000 }
//         );
//       } else {
//         openInMaps(fallbackUrl);
//       }
//     });
//   };

//   // ── Call ─────────────────────────────────────────────────────────────────
//   const handleCallClick = (e) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }

//     const phoneNumber = property.bankContactDetails;

//     if (phoneNumber) {
//       navigator.clipboard.writeText(phoneNumber)
//         .then(() => showAlert?.('success', `Phone number copied: ${phoneNumber}`))
//         .catch(() => showAlert?.('failure', 'Failed to copy phone number'));
//     } else {
//       const userId = property.user_id || property.userId;
//       if (userId) {
//         axios.get(`${BASE_URL}/users/${userId}/`)
//           .then((r) => {
//             const user = r.data;
//             const userPhone = user?.mobile_no || user?.bankContactDetails || user?.phone;
//             if (userPhone) return navigator.clipboard.writeText(userPhone);
//             throw new Error('No phone number found');
//           })
//           .then(() => showAlert?.('success', 'Phone number copied successfully'))
//           .catch(() => showAlert?.('failure', 'No contact information available'));
//       } else {
//         showAlert?.('failure', 'No contact information available');
//       }
//     }
//   };

//   // ── Card click (whole card) ──────────────────────────────────────────────
//   const handleCardClick = (e) => {
//     // ✅ Skip when the click target is inside an interactive element
//     // (carousel arrows, wishlist button, etc.). The View Details button
//     // has its own dedicated handler with stopPropagation, so this guard
//     // no longer blocks navigation from the button.
//     const isInteractive =
//       e.target.closest('button') ||
//       e.target.closest('svg') ||
//       e.target.closest('path');
//     if (isInteractive) return;

//     if (isGuest) { setShowGuestModal(true); return; }
//     localStorage.setItem('lastViewedPropertyId', property.id);
//     navigate(`/Post_Bankcard_indetail/${property.id}`);
//   };

//   // ✅ NEW: View Details button — navigates directly, bypassing the guard
//   const handleViewDetailsClick = (e) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     localStorage.setItem('lastViewedPropertyId', property.id);
//     navigate(`/Post_Bankcard_indetail/${property.id}`);
//   };

//   // ── Display values ───────────────────────────────────────────────────────
//   const auctionDateText = property.auctionEnd
//     ? `${new Date(property.auctionStart).toLocaleDateString('en-IN')} – ${new Date(property.auctionEnd).toLocaleDateString('en-IN')}`
//     : '-';

//   const locationLine = property.area_town || property.locality || '-';
//   const cityLine = property.city_town || property.city || '';
//   const bankName = property.bankName || property.title || '-';

//   return (
//     <>
//       <Card
//         onClick={handleCardClick}
//         sx={{
//           display: 'flex',
//           flexDirection: 'row',
//           width: '100%',
//           height: 135,
//           maxWidth: 290,
//           cursor: 'pointer',
//           borderRadius: 2,
//           overflow: 'hidden',
//           transform: selected ? 'translateY(-2px)' : 'none',
//           transition: 'transform 200ms, border-color 200ms',
//           boxShadow: selected
//             ? '0 4px 12px rgba(0,0,0,0.5)'
//             : '0 2px 6px rgba(0,0,0,0.3)',
//           bgcolor: '#fff',
//           flexShrink: 0,
//         }}
//       >
//         {/* ── LEFT: Image 38% ─────────────────────────────────────────────── */}
//         <Box sx={{ position: 'relative', width: '38%', height: '100%' }}>
//           <CardMedia
//             component="img"
//             image={getCurrentImageUrl()}
//             alt="Property"
//             onError={handleImageError}
//             sx={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               borderTopLeftRadius: 8,
//               borderBottomLeftRadius: 8,
//             }}
//           />

//           {hasMultipleImages && (
//             <>
//               <IconButton
//                 onClick={prevImage}
//                 sx={{
//                   position: 'absolute', top: '50%', left: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.5)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//               >
//                 <ChevronLeft fontSize="small" />
//               </IconButton>
//               <IconButton
//                 onClick={nextImage}
//                 sx={{
//                   position: 'absolute', top: '50%', right: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.5)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//               >
//                 <ChevronRight fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {hasMultipleImages && (
//             <Box sx={{
//               position: 'absolute', bottom: 6, left: '50%',
//               transform: 'translateX(-50%)', display: 'flex', gap: '4px',
//             }}>
//               {images.map((_, index) => (
//                 <Box
//                   key={index}
//                   onClick={(e) => handleDotClick(index, e)}
//                   sx={{
//                     width: 6, height: 6, borderRadius: '50%',
//                     backgroundColor: currentImageIndex === index ? '#1976d2' : '#ccc',
//                     cursor: 'pointer',
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>

//         {/* ── RIGHT: Content 62% ──────────────────────────────────────────── */}
//         <CardContent
//           sx={{
//             width: '62%', p: 1,
//             display: 'flex', flexDirection: 'column',
//             justifyContent: 'space-between',
//             height: 135, boxSizing: 'border-box',
//             '&:last-child': { pb: 1 },
//           }}
//         >
//           {/* Row 1: Property Type */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.2 }}>
//             <Typography
//               fontWeight="bold"
//               noWrap
//               sx={{
//                 fontSize: '0.75rem', lineHeight: 1.2,
//                 overflow: 'hidden', textOverflow: 'ellipsis',
//                 maxWidth: '100%',
//               }}
//             >
//               {property.propertyType || property.property_type || '-'}
//             </Typography>
//           </Box>

//           {/* Row 2: Reserve Price | Bank */}
//           <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.1, mb: 0.2 }}>
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Reserve Price
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.68rem', color: '#c98a2c', lineHeight: 1.2 }}>
//                 ₹{formatPrice(property.reserve_price || property.price)}
//               </Typography>
//             </Box>

//             <Box sx={{ width: '1px', height: 26, bgcolor: '#e0e0e0', mx: 0.6 }} />

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Bank
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.6rem', lineHeight: 1.2 }} noWrap>
//                 {bankName}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Row 3: Location (click → opens maps) */}
//           <Box
//             onClick={handleLocationClick}
//             role="button"
//             tabIndex={0}
//             sx={{
//               display: 'flex',
//               alignItems: 'flex-start',
//               gap: 0.5,
//               mt: 0.1, mb: 0.1,
//               cursor: 'pointer',
//               borderRadius: 1, px: 0.3,
//               transition: 'background-color 0.15s',
//               '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
//             }}
//           >
//             <LocationOn
//               sx={{
//                 fontSize: '0.9rem',
//                 color: '#c98a2c',
//                 flexShrink: 0,
//                 mt: 0.15,
//               }}
//             />

//             <Typography
//               sx={{
//                 minWidth: 0,
//                 flex: 1,
//                 fontSize: '0.6rem',
//                 color: '#333',
//                 fontWeight: 500,
//                 lineHeight: 1.2,
//                 overflow: 'hidden',
//                 display: '-webkit-box',
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: 'vertical',
//                 textOverflow: 'ellipsis',
//                 whiteSpace: 'normal',
//                 textDecoration: 'underline',
//                 textDecorationColor: 'rgba(201,138,44,0.4)',
//               }}
//             >
//               {property.fullLocation ||
//                 property.location ||
//                 property.area_town ||
//                 'Location not available'}
//             </Typography>
//           </Box>

//           {/* Row 4: Auction Date (full width) */}
//           <Box
//             sx={{
//               display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//               mt: 0.2, mb: 0.2, border: '1px solid #e0e0e0',
//               borderRadius: '8px', overflow: 'hidden', minHeight: 26,
//             }}
//           >
//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.4 }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1 }}>
//                 {auctionDateText}
//               </Typography>
//               <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
//                 Auction Date
//               </Typography>
//             </Box>
//           </Box>

//           {/* Row 5: View Details */}
//           <Button
//             variant="contained"
//             size="small"
//             fullWidth
//             onClick={handleViewDetailsClick}   /* ✅ dedicated handler */
//             sx={{
//               mt: 0.2, py: 0.18,
//               fontSize: '0.7rem', fontWeight: 600,
//               bgcolor: '#c98a2c', color: '#000',
//               borderRadius: '2px',
//               '&:hover': { bgcolor: '#f5f5f5' },
//               textTransform: 'none',
//               minHeight: 22,
//               display: 'flex', justifyContent: 'space-between',
//               alignItems: 'center', px: 1.5,
//             }}
//           >
//             View Details
//             <ArrowForward sx={{ fontSize: '0.9rem' }} />
//           </Button>
//         </CardContent>
//       </Card>

//       <GuestLoginModal
//         open={showGuestModal}
//         onClose={() => setShowGuestModal(false)}
//       />
//     </>
//   );
// }



import { useState, useContext, useEffect, useRef } from 'react';
import {
  Card, CardMedia, CardContent, Box, Typography,
  IconButton, Button, CircularProgress,
} from '@mui/material';
import {
  Call, LocationOn, ChevronLeft, ChevronRight, ArrowForward,
} from '@mui/icons-material';
import { AuthContext } from './../../AuthContext/AuthContext';
import GuestLoginModal from '../../GuestLoginModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from './../../Api/ApiUrls';

// ✅ Import the fallback image as a bundled asset (no network request, no blinking)
import buildingImage from './../../../Images/house.jpeg';

const FALLBACK_IMAGE = buildingImage;

// ─── Helpers ─────────────────────────────────────────────────────────────────
const formatPropertyId = (id) => `PR${String(id || '').padStart(4, '0')}`;

const formatPrice = (price) => {
  const num = Number(price);
  if (!num || isNaN(num) || num <= 0) return '0';
  return num.toLocaleString('en-IN');
};

const getPriceLabel = (price) => {
  const num = Number(price);
  if (!num || isNaN(num) || num <= 0) return '0';
  if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000)   return `${(num / 100000).toFixed(2)} L`;
  if (num >= 1000)     return `${(num / 1000).toFixed(2)} K`;
  return num.toLocaleString('en-IN');
};

// ✅ Normalize any image URL (string or object) → absolute URL, or null
const normalizeImageUrl = (raw) => {
  if (!raw) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s;
  const base = String(BASE_URL || '').replace(/\/+$/, '');
  return `${base}/${s.replace(/^\/+/, '')}`;
};

export default function AuctionPropertyCard({
  property,
  onCardClick,
  onCallClick,
  onMapClick,
  images = [],
  showAlert,
  selected = false,
}) {
  const { isGuest } = useContext(AuthContext);
  const navigate = useNavigate();

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [imageErrors, setImageErrors] = useState({});
  const [showGuestModal, setShowGuestModal] = useState(false);

  // ✅ Image-loaded state — spinner overlay + fade-in, no blinking
  const [imageLoaded, setImageLoaded] = useState(false);

  const hasMultipleImages = images.length > 1;

  // ── Resolve the current image URL ─────────────────────────────────────────
  const getCurrentImageUrl = () => {
    if (!images || images.length === 0) return FALLBACK_IMAGE;
    if (imageErrors[currentImageIndex]) return FALLBACK_IMAGE;

    const img = images[currentImageIndex];
    const raw = typeof img === 'string' ? img : (img?.url || img?.image || img?.path || '');
    const normalized = normalizeImageUrl(raw);
    return normalized || FALLBACK_IMAGE;
  };

  const currentImageUrl = getCurrentImageUrl();

  // ✅ Reset imageLoaded whenever the active image URL changes
  useEffect(() => {
    setImageLoaded(false);
  }, [currentImageUrl]);

  const handleImageError = () => {
    // Only record an error if we're not already showing the fallback
    if (currentImageUrl !== FALLBACK_IMAGE) {
      setImageErrors((prev) => ({ ...prev, [currentImageIndex]: true }));
    }
    setImageLoaded(true); // stop spinner even if the fallback is shown
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    if (!hasMultipleImages) return;
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    if (!hasMultipleImages) return;
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleDotClick = (index, e) => {
    e.stopPropagation();
    setCurrentImageIndex(index);
  };

  // ── Guest check ──────────────────────────────────────────────────────────
  const checkGuestAndExecute = (cb) => {
    if (isGuest) { setShowGuestModal(true); return false; }
    return cb();
  };

  // ── Location ─────────────────────────────────────────────────────────────
  const handleLocationClick = (e) => {
    e.stopPropagation();
    checkGuestAndExecute(() => {
      setIsLoadingLocation(true);
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const openInMaps = (url) => { setIsLoadingLocation(false); window.location.href = url; };
      const fallbackUrl = isIOS
        ? `http://maps.apple.com/?q=${encodeURIComponent(property.location || '')}`
        : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location || `${property.lat},${property.lng}`)}`;

      if (property.lat && property.lng && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            const mapsUrl = isIOS
              ? `http://maps.apple.com/?daddr=${property.lat},${property.lng}`
              : `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${property.lat},${property.lng}&travelmode=driving`;
            openInMaps(mapsUrl);
          },
          () => openInMaps(fallbackUrl),
          { timeout: 10000 }
        );
      } else {
        openInMaps(fallbackUrl);
      }
    });
  };

  // ── Call ─────────────────────────────────────────────────────────────────
  const handleCallClick = (e) => {
    e.stopPropagation();
    if (isGuest) { setShowGuestModal(true); return; }

    const phoneNumber = property.bankContactDetails;

    if (phoneNumber) {
      navigator.clipboard.writeText(phoneNumber)
        .then(() => showAlert?.('success', `Phone number copied: ${phoneNumber}`))
        .catch(() => showAlert?.('failure', 'Failed to copy phone number'));
    } else {
      const userId = property.user_id || property.userId;
      if (userId) {
        axios.get(`${BASE_URL}/users/${userId}/`)
          .then((r) => {
            const user = r.data;
            const userPhone = user?.mobile_no || user?.bankContactDetails || user?.phone;
            if (userPhone) return navigator.clipboard.writeText(userPhone);
            throw new Error('No phone number found');
          })
          .then(() => showAlert?.('success', 'Phone number copied successfully'))
          .catch(() => showAlert?.('failure', 'No contact information available'));
      } else {
        showAlert?.('failure', 'No contact information available');
      }
    }
  };

  // ── Card click (whole card) ──────────────────────────────────────────────
  const handleCardClick = (e) => {
    const isInteractive =
      e.target.closest('button') ||
      e.target.closest('svg') ||
      e.target.closest('path');
    if (isInteractive) return;

    if (isGuest) { setShowGuestModal(true); return; }
    localStorage.setItem('lastViewedPropertyId', property.id);
    navigate(`/Post_Bankcard_indetail/${property.id}`);
  };

  // ✅ View Details button — navigates directly, bypassing the guard
  const handleViewDetailsClick = (e) => {
    e.stopPropagation();
    if (isGuest) { setShowGuestModal(true); return; }
    localStorage.setItem('lastViewedPropertyId', property.id);
    navigate(`/Post_Bankcard_indetail/${property.id}`);
  };

  // ── Display values ───────────────────────────────────────────────────────
  const auctionDateText = property.auctionEnd
    ? `${new Date(property.auctionStart).toLocaleDateString('en-IN')} – ${new Date(property.auctionEnd).toLocaleDateString('en-IN')}`
    : '-';

  const bankName = property.bankName || property.title || '-';

  return (
    <>
      <Card
        onClick={handleCardClick}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: 135,
          maxWidth: 290,
          cursor: 'pointer',
          borderRadius: 2,
          overflow: 'hidden',
          transform: selected ? 'translateY(-2px)' : 'none',
          transition: 'transform 200ms, border-color 200ms',
          boxShadow: selected
            ? '0 4px 12px rgba(0,0,0,0.5)'
            : '0 2px 6px rgba(0,0,0,0.3)',
          bgcolor: '#fff',
          flexShrink: 0,
        }}
      >
        {/* ── LEFT: Image 38% ─────────────────────────────────────────────── */}
        <Box sx={{ position: 'relative', width: '38%', height: '100%', overflow: 'hidden' }}>
          {/* ✅ Always render the img — never unmounted → no blinking */}
          <CardMedia
            component="img"
            image={currentImageUrl}
            alt="Property"
            onLoad={handleImageLoad}
            onError={handleImageError}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderTopLeftRadius: 8,
              borderBottomLeftRadius: 8,
              display: 'block',
              // Fade in once loaded (first paint)
              opacity: imageLoaded ? 1 : 0,
              transition: 'opacity 180ms ease-in',
            }}
          />

          {/* ✅ Spinner overlay — only while the image is decoding */}
          {!imageLoaded && (
            <Box sx={{
              position: 'absolute', inset: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              bgcolor: '#f5f5f5',
              pointerEvents: 'none',
            }}>
              <CircularProgress size={20} />
            </Box>
          )}

          {hasMultipleImages && imageLoaded && (
            <>
              <IconButton
                onClick={prevImage}
                sx={{
                  position: 'absolute', top: '50%', left: 4,
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(255,255,255,0.5)',
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
                  p: 0.3, width: 22, height: 22,
                }}
              >
                <ChevronLeft fontSize="small" />
              </IconButton>
              <IconButton
                onClick={nextImage}
                sx={{
                  position: 'absolute', top: '50%', right: 4,
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(255,255,255,0.5)',
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
                  p: 0.3, width: 22, height: 22,
                }}
              >
                <ChevronRight fontSize="small" />
              </IconButton>
            </>
          )}

          {hasMultipleImages && imageLoaded && (
            <Box sx={{
              position: 'absolute', bottom: 6, left: '50%',
              transform: 'translateX(-50%)', display: 'flex', gap: '4px',
            }}>
              {images.slice(0, 5).map((_, index) => (
                <Box
                  key={index}
                  onClick={(e) => handleDotClick(index, e)}
                  sx={{
                    width: 6, height: 6, borderRadius: '50%',
                    backgroundColor: currentImageIndex === index ? '#1976d2' : '#ccc',
                    cursor: 'pointer',
                  }}
                />
              ))}
            </Box>
          )}
        </Box>

        {/* ── RIGHT: Content 62% ──────────────────────────────────────────── */}
        <CardContent
          sx={{
            width: '62%', p: 1,
            display: 'flex', flexDirection: 'column',
            justifyContent: 'space-between',
            height: 135, boxSizing: 'border-box',
            '&:last-child': { pb: 1 },
          }}
        >
          {/* Row 1: Property Type */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.2 }}>
            <Typography
              fontWeight="bold"
              noWrap
              sx={{
                fontSize: '0.75rem', lineHeight: 1.2,
                overflow: 'hidden', textOverflow: 'ellipsis',
                maxWidth: '100%',
              }}
            >
              {property.propertyType || property.property_type || '-'}
            </Typography>
          </Box>

          {/* Row 2: Reserve Price | Bank */}
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.1, mb: 0.2 }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
                Reserve Price
              </Typography>
              <Typography fontWeight="bold" sx={{ fontSize: '0.68rem', color: '#8B4F16', lineHeight: 1.2, fontWeight: 900  }}>
                ₹{formatPrice(property.reserve_price || property.price)}
              </Typography>
            </Box>

            <Box sx={{ width: '1px', height: 26, bgcolor: '#e0e0e0', mx: 0.6 }} />

            <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
              <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
                Bank
              </Typography>
              <Typography fontWeight="bold" sx={{ fontSize: '0.6rem', lineHeight: 1.2 }} noWrap>
                {bankName}
              </Typography>
            </Box>
          </Box>

          {/* Row 3: Location (click → opens maps) */}
          <Box
            onClick={handleLocationClick}
            role="button"
            tabIndex={0}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 0.5,
              mt: 0.1, mb: 0.1,
              cursor: 'pointer',
              borderRadius: 1, px: 0.3,
              transition: 'background-color 0.15s',
              '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
            }}
          >
            <LocationOn
              sx={{
                fontSize: '0.9rem',
                color: '#8B4F16',
                flexShrink: 0,
                mt: 0.15,
              }}
            />

            <Typography
              sx={{
                minWidth: 0,
                flex: 1,
                fontSize: '0.6rem',
                color: '#333',
                fontWeight: 500,
                lineHeight: 1.2,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                textDecoration: 'underline',
                textDecorationColor: 'rgba(201,138,44,0.4)',
              }}
            >
              {property.fullLocation ||
                property.location ||
                property.area_town ||
                'Location not available'}
            </Typography>
          </Box>

          {/* Row 4: Auction Date (full width) */}
          <Box
            sx={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              mt: 0.2, mb: 0.2, border: '1px solid #e0e0e0',
              borderRadius: '8px', overflow: 'hidden', minHeight: 26,
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.4 }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1, fontWeight: 900 }}>
                {auctionDateText}
              </Typography>
              <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
                Auction Date
              </Typography>
            </Box>
          </Box>

          {/* Row 5: View Details */}
          <Button
            variant="contained"
            size="small"
            fullWidth
            onClick={handleViewDetailsClick}
            sx={{
              mt: 0.2, py: 0.18,
              fontSize: '0.7rem', fontWeight: 600,
              bgcolor: '#8B4F16', color: '#fff',
              borderRadius: '2px',
              '&:hover': { bgcolor: '#f5f5f5' },
              textTransform: 'none',
              minHeight: 22,
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', px: 1.5,
            }}
          >
            View Details
            <ArrowForward sx={{ fontSize: '0.9rem' }} />
          </Button>
        </CardContent>
      </Card>

      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />
    </>
  );
}